export default __webpack_public_path__ + "static/media/landing-page-icon.0ca2fddc.svg";